module.exports = __webpack_public_path__ + "static/media/Brno-Kohoutovice.d84169c3.jpg";